// extracted by mini-css-extract-plugin
module.exports = {"image":"CarouselProduct_image___AJMZ","thumbnail":"CarouselProduct_thumbnail__nvj0Y","carousel_wrapper":"CarouselProduct_carousel_wrapper__cood3"};